/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useState } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import SkinDrawer from '@views/MyPage/SkinDrawer'
import { message } from 'antd'
// icon
import { ImgIco, SkinSelectIco, ProfileResetIco } from '@shared/Icon/EtcIcon'
// css
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { AdvSlideUpModalStyle } from '@styles/modal'
import { ChangeProfileWrap } from './index.style'
import { authStore } from '@store/index'
import { PROPERTY_ID } from 'adv-protocol/src/GameCommon'

const ChangeProfilePopup: React.FC = () => {
  const { globalStore, userStore, chattingStore } = useRootStore()
  const { visibleChangeProfile, setVisibleChangeProfile } = globalStore
  const [visibleSkin, setVisibleSkin] = useState(false)

  const onClickChangeProfilePopupClose = () => {
    globalStore.setIgnoreVisibleChangeHandler(false)
    setVisibleChangeProfile(false)
  }

  const onChangeUserProfilePhotoSelectHandler = (event) => {
    event.preventDefault()
    const reader = new FileReader()
    const file = event.target.files[0]
    reader.onload = async () => {
      // 유저가 선택한 임의의 이미지 용량을 줄이기 위해
      // 이미지 용량을 줄여서 S3 에 저장하는 기능을 가진
      // 채팅 서버쪽에 임시로 이미지 업로드를 진행.
      // TODO 추후 기능을 v2 서버에 구현해서 처리 해야함.
      const uploadedProfileImageName = await chattingStore.uploadProfileImage(file)
      await userStore.changeProfileImageByCustomPhoto(uploadedProfileImageName)
      await userStore.getUserItems([PROPERTY_ID.AVATAR])
      await authStore.refreshSimpleUserInfo(true)
      message.info('프로필 사진이 변경 되었습니다')
      setVisibleChangeProfile(false)
    }
    reader.readAsDataURL(file)
  }

  const onClickProfileImageReset = async () => {
    await userStore.resetProfileImage()
    await authStore.refreshSimpleUserInfo(false)
    message.info('프로필 사진이 변경 되었습니다')
    setVisibleChangeProfile(false)
    globalStore.setIgnoreVisibleChangeHandler(false)
  }

  const onClickVisibleSkin = () => {
    setVisibleSkin(true)
    globalStore.setIgnoreVisibleChangeHandler(false)
  }

  return (
    <Fragment>
      <Modal
        popup
        visible={visibleChangeProfile}
        maskClosable={false}
        animated={isMobile}
        animationType="slide-up"
        onClose={onClickChangeProfilePopupClose}
        className="short-top pc-close-btn-modal new-slide-modal"
        css={AdvSlideUpModalStyle}
      >
        {!isMobile &&
        <Button circle onClick={onClickChangeProfilePopupClose} css={CloseBtn} className="close-btn modal-circle-close-btn">
          <span className="close-txt">닫기</span>
        </Button>
        }

        <ChangeProfileWrap>
          <input type="file"
                 accept="image/*"
                 name="select_photo_img"
                 id="selectUserProfilePhotoImg"
                 className="select-photo-input"
                 onChange={onChangeUserProfilePhotoSelectHandler}/>
          <label htmlFor="selectUserProfilePhotoImg" className="change-profile-btn" onTouchStart={() => {
            globalStore.setIgnoreVisibleChangeHandler(true)
          }}>
            <span className="ico-wrap">
              <ImgIco/>
            </span>
            사진첩
          </label>

          <Button className="change-profile-btn" onClick={onClickVisibleSkin}>
            <span className="ico-wrap">
              <SkinSelectIco/>
            </span>
            스킨
          </Button>
          <Button className="change-profile-btn reset" onClick={onClickProfileImageReset}>
            <span className="ico-wrap">
              <ProfileResetIco/>
            </span>
            프로필 초기화
          </Button>
        </ChangeProfileWrap>

        <Button onClick={onClickChangeProfilePopupClose} className="one-bottom-btn">
          닫기
        </Button>

        <ModalBg onClick={onClickChangeProfilePopupClose}/>
      </Modal>

      <SkinDrawer visible={visibleSkin} setVisible={setVisibleSkin}/>
    </Fragment>
  )
}
export default observer(ChangeProfilePopup)
